import Keycloak from 'keycloak-js';

export const keycloak = new (Keycloak as any)({
  url: process.env.LOGIN_APP,
  realm: process.env.REALM,
  clientId: process.env.CLIENT_ID,
});

keycloak.onTokenExpired = () => {
  keycloak.updateToken(30).catch(() => {
    logout();
  });
};

export const login = () => keycloak.login({ scope: 'openid roles email profile tenant' });

export const logout = () => keycloak.logout();

export const doAuthentication = () =>
  keycloak
    .init({
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
    })
    .then(authenticated => {
      if (!authenticated) {
        return login();
      }
      const { email, name, tenant, sub } = keycloak.tokenParsed;
      return { isAuthenticated: !!authenticated, userData: { email, name, tenant, sub } };
    })
    .catch(error => {
      // eslint-disable-next-line no-console
      console.log('failed to initialize: ', error);
    });
